(() => {
  document.querySelectorAll('[data-soma-pads]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const choices = [...root.querySelectorAll('[data-bundle-choice]')];
    const buttons = [...root.querySelectorAll('[data-add]')];
    const status = root.querySelector('.sr-cart-status');
    const main = root.querySelector('[data-sr-main]');
    const format = n => new Intl.NumberFormat('fr-FR', {style:'currency',currency:root.dataset.currency || window.Shopify?.currency?.active || 'USD'}).format(n/100);
    let pending = false;
    const selected = () => choices.find(choice => choice.checked) || choices[0];
    function update(changeUrl = false) {
      const choice = selected();
      if (!choice) return;
      const count = Number(choice.dataset.count), price = Number(choice.dataset.price);
      const savings = Math.max(0, Number(choice.dataset.reference) - price);
      const referenceTotal = Number(choice.dataset.reference);
      const percent = Math.floor(savings * 100 / referenceTotal);
      root.querySelectorAll('[data-reference-total]').forEach(el => {el.textContent = format(referenceTotal);});
      root.querySelectorAll('[data-offer-label]').forEach(el => {el.textContent = `−${percent} %`;});
      root.dataset.variant = choice.value;
      root.dataset.price = String(price);
      root.dataset.available = choice.dataset.available;
      root.querySelectorAll('[data-total]').forEach(el => {el.textContent = format(price);});
      root.querySelectorAll('[data-kit-count]').forEach(el => {el.textContent = `${count} sachet${count > 1 ? 's' : ''}`;});
      root.querySelectorAll('[data-gift-summary]').forEach(el => {el.textContent = `${count*40} cotons + ${count} savon${count>1?'s':''} offert${count>1?'s':''}`;});
      root.querySelectorAll('[data-bundle-savings]').forEach(el => {
        el.hidden = savings === 0;
        el.textContent = `Économisez ${format(savings)}`;
      });
      buttons.forEach(el => {el.disabled = pending || choice.dataset.available !== 'true';});
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', choice.value);
        window.history.replaceState(null, '', url);
      }
    }
    choices.forEach(choice => choice.addEventListener('change', () => {
      if (!pending) {update(true); status.textContent = '';}
    }));
    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const choice = choices.find(item => item.value === id) || choices[0];
      if (choice && !choice.disabled && !pending) {choice.checked = true; update();}
    });
    root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      main.src = button.dataset.image;
      main.alt = button.getAttribute('aria-label');
      root.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const setPending = value => {
      pending = value;
      choices.forEach(el => {el.disabled = value || el.dataset.available !== 'true';});
      buttons.forEach(el => {el.disabled = value || selected().dataset.available !== 'true'; el.setAttribute('aria-busy', String(value));});
    };
    const addToCart = async event => {
      event.preventDefault();
      if (pending) return;
      update();
      const choice = selected();
      if (!choice || choice.dataset.available !== 'true') {status.textContent = 'Cette offre est momentanément indisponible.'; return;}
      setPending(true);
      status.textContent = 'Ajout de votre sélection au panier…';
      let added = false;
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer?.renderContents || !drawer?.getSectionsToRender) throw new Error('Le panier est en cours de chargement. Réessayez.');
        drawer.setActiveElement(event.currentTarget);
        const sections = drawer.getSectionsToRender().map(section => section.id);
        const base = (root.dataset.root || '/').replace(/\/?$/, '/');
        const response = await fetch(base+'cart/add.js', {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(choice.value),quantity:1}],sections,sections_url:window.location.pathname})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Impossible d’ajouter votre sélection. Réessayez.');
        added = true;
        if (sections.some(id => !data.sections?.[id])) {
          const refreshed = await fetch(window.location.pathname+'?sections='+sections.join(','), {cache:'no-store'});
          data.sections = await refreshed.json();
        }
        if (sections.some(id => !data.sections?.[id])) throw new Error('Le panier n’a pas pu être actualisé.');
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        status.textContent = '';
      } catch (error) {
        status.textContent = added ? 'Votre sélection a été ajoutée. Cliquez sur l’icône du panier pour la consulter.' : error.message || 'La connexion a été interrompue. Réessayez.';
      } finally {setPending(false);}
    };
    buttons.forEach(button => {button.setAttribute('aria-haspopup', 'dialog'); button.addEventListener('click', addToCart);});
    const sticky = root.querySelector('[data-sticky]');
    if (sticky && typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }, {threshold:0}).observe(root.querySelector('.sr-buy-line'));
    }
    update();
  });
})();
